import AOS from 'aos'

// Initialize Animate On Scroll
AOS.init();
